<template>
  <div>
    <div v-if="!text">
      <canvas
        id="myChart33"
      />
      <div
        v-if="porcentagemClientesFaturados"
        id="porcentagemClienteFaturado"
        :style="styleCliente"
      >
        {{ porcentagemClientesFaturados }}
      </div>
    </div>
    <div
      v-else
    >
      {{ text }}
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardCoberturaParticipantes',
    emits: ['envioCoberturaParticipantes'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },

    data: () => ({
      myChart: {},
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      styleCliente: {
        color: '#ed934f',
      },
      enableGrafico: true,
      text: null,
      montaGrafico: true,
      clientesFaturado: 0,
      clientesTotalAtivos: 0,
      porcentagemClientesFaturados: null,
      porcentagemClientesFaturado: 0,
      restantePorcentagem: 0,
    }),

    created () {
      eventEmit.$on('set-cobertura-participantes', this.handleUpdateDados)

      eventEmit.$on('enable-cobertura-participantes', this.updateGrafico)
    },

    beforeDestroy () {
      eventEmit.$off('set-cobertura-participantes', this.handleUpdateDados)

      eventEmit.$off('enable-cobertura-participantes', this.updateGrafico)
    },

    methods: {
      handleUpdateDados (clientesFaturado, clientesTotalAtivos) {
        this.clientesFaturado = clientesFaturado
        this.clientesTotalAtivos = clientesTotalAtivos

        this.MontarGrafico()
      },

      updateGrafico (porcentagem, restante) {
        this.updateGraficoPrint(porcentagem, restante)
      },

      MontarGrafico () {
        if (this.montaGrafico) {
          this.montaGrafico = false

          const porcentagemClientesFaturado = (this.clientesFaturado / this.clientesTotalAtivos) * 100
          const restantePorcentagem = 100 - porcentagemClientesFaturado

          this.porcentagemClientesFaturados = porcentagemClientesFaturado.toFixed(2).toString().replace('.', ',') + '%'

          eventEmit.$emit('envio-cobertura-participantes', porcentagemClientesFaturado, restantePorcentagem)

          const ctx = document.getElementById('myChart33').getContext('2d')
          this.myChart = new Chart(ctx, {
            type: 'doughnut',
            data: {
              labels: ['Porcentagem'],
              datasets: [
                {
                  label: 'Porcentagem',
                  data: [porcentagemClientesFaturado, restantePorcentagem],
                  backgroundColor: [
                    '#ed934f',
                    '#cadaed',
                  ],
                },
              ],
            },
            options: {
              legend: {
                display: false,
              },
              responsive: true,
              cutoutPercentage: 70,
              tooltips: {
                enabled: false,
              },
            },
          })
        } else {
          this.myChart.destroy()
          this.porcentagemClientesFaturados = null

          const porcentagemClientesFaturado = (this.clientesFaturado / this.clientesTotalAtivos) * 100
          const restantePorcentagem = 100 - porcentagemClientesFaturado

          eventEmit.$emit('envio-cobertura-participantes', porcentagemClientesFaturado, restantePorcentagem)

          this.porcentagemClientesFaturados = porcentagemClientesFaturado.toFixed(2).toString().replace('.', ',') + '%'

          const ctx = document.getElementById('myChart33').getContext('2d')
          this.myChart = new Chart(ctx, {
            type: 'doughnut',
            data: {
              labels: ['Faturamento', 'Meta'],
              datasets: [
                {
                  label: 'Faturamento',
                  data: [porcentagemClientesFaturado, restantePorcentagem],
                  backgroundColor: [
                    '#ed934f',
                    '#cadaed',
                  ],
                },
              ],
            },
            options: {
              legend: {
                display: false,
              },
              responsive: true,
              cutoutPercentage: 70,
              tooltips: {
                enabled: false,
              },
            },
          })
        }
      },

      updateGraficoPrint (porcentagem, restante) {
        this.porcentagemClientesFaturados = porcentagem.toFixed(2).toString().replace('.', ',') + '%'

        const ctx = document.getElementById('myChart33').getContext('2d')
        this.myChart = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: ['Faturamento', 'Meta'],
            datasets: [
              {
                label: 'Faturamento',
                data: [porcentagem, restante],
                backgroundColor: [
                  '#ed934f',
                  '#cadaed',
                ],
              },
            ],
          },
          options: {
            legend: {
              display: false,
            },
            responsive: true,
            cutoutPercentage: 70,
            tooltips: {
              enabled: false,
            },
          },
        })
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    #porcentagemClienteFaturado {
      margin: -7rem 0 1rem 0rem
    }
  }

  @media screen
  and (min-width : 600px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #porcentagemClienteFaturado {
      margin: -7rem 0 4rem 0rem;
    }

    #myChart33 {
      width: 350px !important;
      height: 169px !important;
      margin: -1rem 0 0 17.5rem;
    }
  }

  @media screen
  and (min-width : 1380px)
  and (max-width : 1795px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #porcentagemClienteFaturado {
      margin: -7rem 0 6rem 0rem;
    }

    #myChart33 {
      width: 408px !important;
      height: 220px !important;
    }
  }

  @media screen
  and (min-width : 1800px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #porcentagemClienteFaturado {
      margin: -9rem 0 6rem 0.5rem;
    }

    #myChart33 {
      margin: -0.5rem 0 0 0rem;
      width: 408px !important;
      height: 220px !important;
    }
  }
</style>

<style lang="sass">
  #myChart33
    margin: -1.5rem 0 0 0

  #porcentagemClienteFaturado
    margin: -6.5rem 0 3rem 0
    font-weight: bold
    font-size: 22px

</style>
